// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tupR","field":"styles_field__mqRRD","fieldCol":"styles_fieldCol__26Ahn","diffCol":"styles_diffCol__2oMGj","diff":"styles_diff__27OcO"};